import { PublicRoute } from ".";
import Login from "../pages/public/Login";

const publicRoutes = [
  {
    path: "",
    element: <PublicRoute />,
    children: [
      {
        path: "",
        element: <Login />,
      },
    ],
  },
];

export default publicRoutes;
